// The shell is worth having on a phone that has walked behind the bar; §20.
export const SERVICE_WORKER_URL = '/sw.js';

export type Registrar = Pick<ServiceWorkerContainer, 'register'>;

// Dev is excluded: Vite serves the shell itself and a worker would shadow HMR.
export async function registerServiceWorker(
  registrar: Registrar | undefined,
  enabled: boolean,
): Promise<boolean> {
  if (!enabled || registrar === undefined) return false;
  try {
    await registrar.register(SERVICE_WORKER_URL, { type: 'module', scope: '/' });
    return true;
  } catch {
    // An unsupported or refused worker costs the offline shell, not the app.
    return false;
  }
}
